




































import { Component, Prop, Vue } from 'vue-property-decorator';
import { ConfigService } from '@/services/ConfigService';
import { EssenceItemDto, EssencesApi } from '@eurogast/hub-client-typescript';
import { ApiService } from '@/services/ApiService';

@Component
export default class EssenceList extends Vue {
  public isLoggedIn: boolean = ConfigService.isLoggedIn();
  public showEssenceList = true;
  public isEssenceShown = true;
  public activeEssenceListItem: EssenceItemDto = null;

  public essenceList: EssenceItemDto[] = null;

  get visibility(): string {
    return this.isEssenceShown ? 'visibility' : 'visibility_off';
  }

  get visibilityText(): string {
    return this.isEssenceShown ? this.$t('productDetail.essenceList.visibleOnEssenceList').toString() :
      this.$t('productDetail.essenceList.hiddenOnEssenceList').toString();
  }

  @Prop({ required: true })
  public localSku: string;

  @Prop({ required: true })
  public localEssential: string;

  private api = ApiService.wrap(EssencesApi);

  public mounted() {
    this.isEssenceShown = this.localEssential === 'true';
    if (ConfigService.isLoggedIn()) {
      this.api.getLastThreeEssenceItems(ConfigService.getTenant(), ConfigService.currentCustomerId, this.localSku)
        .then((res) => {
          this.essenceList = res;
          if (this.essenceList && this.essenceList.length > 0) {
            this.activeEssenceListItem = this.essenceList[0];
          }
        })
        .catch(ApiService.defaultErrorHandler);
    }
  }

  public isActive(index): boolean {
    return index === this.essenceList.indexOf(this.activeEssenceListItem);
  }

  public setActiveItem(item: EssenceItemDto) {
    this.activeEssenceListItem = item;
  }

  public toggleEssenceVisibility() {
    const newVisibility = !this.isEssenceShown;
    this.api
      .setEssenceVisibility(ConfigService.getTenant(), ConfigService.currentCustomerId, this.localSku, newVisibility)
      .then(() => {
        this.isEssenceShown = newVisibility;
      })
      .catch(ApiService.defaultErrorHandler);
  }

  public toggleEssenceList() {
    this.showEssenceList = !this.showEssenceList;
  }

  public getTimeframe(date: string): string {
    let difference = Math.floor((new Date().getTime() - new Date(date).getTime()) / 1000 / 60 / 60 / 24);
    let unit = this.$tc('productDetail.essenceList.days', difference).toString();
    //  days, weeks & months (> 7 days => weeks, > 4 weeks => months)
    if (difference > 7) {
      difference = Math.floor(difference / 7);
      unit = this.$tc('productDetail.essenceList.weeks', difference).toString();

      if (difference > 4) {
        difference = Math.floor(difference / 4);
        unit = this.$tc('productDetail.essenceList.months', difference).toString();
      }
    }

    return difference + ' ' + unit;
  }

  private formatDate(date: string) {
    const priceDate = new Date(date);
    return priceDate.toLocaleDateString('de-AT');
  }
}
